import React, { useEffect, useState } from 'react';
import { Card, CardBody, CardHeader, Col, Container, Row } from 'reactstrap';
import withRouter from '../.././components/withRouter';
import { useProfile } from '../../hooks/UserHooks';
import TableContainer from '../../components/TableContainerReactTable';
import { getCampaigns } from '../../api/campaignApi';
import { getTags } from '../../api/tagApi';
import { format } from 'date-fns';

const Index = (props: any) => {
    const { userProfile } = useProfile();
    const [loadingCampaigns, setLoadingCampaigns] = useState<boolean>(true);
    const [loadingTags, setLoadingTags] = useState<boolean>(true);
    const [campaigns, setCampaigns] = useState<any>([]);
    const [tags, setTags] = useState<any>([]);
    
    useEffect(() => {
        getCampaigns().then((res) => {
            setCampaigns(res);
        }).finally(() => {
            setLoadingCampaigns(false);
        });

        getTags().then((res) => {
            setTags(res);
        }).finally(() => {
            setLoadingTags(false);
        });
    }, []);

    const campaignsColumns = [
        {
            header: "Nome",
            accessorKey: "name",
            enableColumnFilter: false,
            enableSorting: true,
        },
        {
            header: "Pedidos",
            accessorKey: "orders.length",
            enableColumnFilter: false,
            enableSorting: true,
        },
        {
            header: 'Data de Início',
            accessorFn: (row: any) => {
                // Campaigns em ordem crescente de data de início
                const campaigns = row.orders.sort((a: any, b: any) => new Date(a.startDate).getTime() - new Date(b.startDate).getTime());
                return campaigns[0]?.startDate ? format(new Date(campaigns[0].startDate), 'dd/MM/yyyy') : '-';
            },
            enableColumnFilter: false,
        },
        {
            header: 'Data de Termino',
            accessorFn: (row: any) => {
                // Campaigns em ordem decrescente de data de término
                const campaigns = row.orders.sort((a: any, b: any) => new Date(b.endDate).getTime() - new Date(a.endDate).getTime());
                return campaigns[0]?.endDate ? format(new Date(campaigns[0].endDate), 'dd/MM/yyyy') : '-';
            },
            enableColumnFilter: false,
        },
        {
            header: "Impressões",
            accessorKey: "impressions",
            enableColumnFilter: false,
            enableSorting: true,
        },
    ];

    const tagsColumns = [
        {
            header: "Domínio",
            accessorKey: "domain",
            enableColumnFilter: false,
            enableSorting: true,
        },
        {
            header: "Nome",
            accessorKey: "name",
            enableColumnFilter: false,
            enableSorting: true,
        },
        {
            header: "Formatos",
            accessorFn: (row: any) => {
                const enabledAdFormats = row.placements ? row.placements.filter((placement: any) => placement.enabled) : [];
                return enabledAdFormats.length > 0 ? enabledAdFormats.length : '-';
            },
            enableColumnFilter: false,
            enableSorting: true,
        },
        {
            header: "Requisições",
            accessorKey: "requests",
            enableColumnFilter: false,
            enableSorting: true,
        },
        {
            header: "Última Atualização",
            accessorFn: (row: any) => {
                return row.updatedAt ? format(new Date(row.updatedAt), 'dd/MM/yyyy HH:mm:ss') : '-';
            },
            enableColumnFilter: false,
            enableSorting: true,
        },
    ];

    document.title = 'Dashboard | Ad Pulse';
    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Row>
                        <Col md={12}>
                            <Card className="card-animate mb-4">
                                <CardBody>
                                    <div className="d-flex align-items-center">
                                        <div>
                                            <h4 className="mb-1">Bem-vindo ao Ad Pulse!</h4>
                                            <p className="mb-0 text-muted">
                                                Olá{userProfile?.name ? `, ${userProfile.name}` : ''}! Este é o seu painel do Ad Server. Aqui você pode acompanhar campanhas, TAGs e métricas em tempo real.
                                            </p>
                                        </div>
                                        <div className="ms-auto">
                                            <div className="avatar-sm flex-shrink-0">
                                                <span className="avatar-title bg-primary-subtle rounded-circle fs-2">
                                                    <i className="ri-broadcast-line text-primary fs-2"></i>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>

                    <Row>
                        <Col md={6}>
                            <Card className="card-animate">
                                <CardHeader className="border-0 align-items-center d-flex">
                                    <h4 className="card-title mb-0 flex-grow-1">Campanhas</h4>
                                </CardHeader>
                                <CardBody>
                                    {!loadingCampaigns ? <TableContainer
                                            divClass="table-responsive"
                                            columns={(campaignsColumns || [])}
                                            data={(campaigns || [])}
                                            isGlobalFilter={false}
                                            enablePagination={false}
                                            SearchPlaceholder='Procurar...'
                                        /> :
                                        <div className="text-center">
                                            <div className="spinner-border text-primary" role="status">
                                                <span className="visually-hidden">Carregando...</span>
                                            </div>
                                        </div>}
                                </CardBody>
                            </Card>
                        </Col>

                        <Col md={6}>
                            <Card className="card-animate">
                                <CardHeader className="border-0 align-items-center d-flex">
                                    <h4 className="card-title mb-0 flex-grow-1">TAGs</h4>
                                </CardHeader>
                                <CardBody>
                                    {!loadingTags ? <TableContainer
                                            divClass="table-responsive"
                                            columns={(tagsColumns || [])}
                                            data={(tags || [])}
                                            isGlobalFilter={false}
                                            enablePagination={false}
                                            SearchPlaceholder='Procurar...'
                                        /> :
                                        <div className="text-center">
                                            <div className="spinner-border text-primary" role="status">
                                                <span className="visually-hidden">Carregando...</span>
                                            </div>
                                        </div>}
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default withRouter(Index);